export default __webpack_public_path__ + "static/media/jen-low-imapce-icon2.92beca93.svg";